import { ELEMENT_GROUPS } from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'FunnelDashboard',
  label: 'Funnel Dashboard',
  icon: 'DocumentTextIcon',
  description: 'Displays a dashboard for funnels',
  properties: []
};

export default fields;
